import { render } from "./RemoteSearch.vue?vue&type=template&id=318ce8b2"
import script from "./RemoteSearch.vue?vue&type=script&lang=js"
export * from "./RemoteSearch.vue?vue&type=script&lang=js"
script.render = render

export default script